
export default {
  name: "CardNovidades",
  props: {
    pacote: {
      type: Object,
      default: null,
    },
  },
  computed: {
    totalItens() {
      return this.pacote && this.pacote.itens ? this.pacote.itens.length : 0;
    },
  },
};
